export default __webpack_public_path__ + "static/media/landing.89aa502f.jpeg";